import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentPickup } from '../../lib/types/models/enrollment/enrollment-pickup'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentPickup<T extends FieldsSelector<EnrollmentPickup>>(
  id: number,
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.enrollments.getEnrollmentPickup.url, { id }), {
        fields
      })
    )
    .get<SelectFields<EnrollmentPickup, T>>()
}
